import { TeamStats } from '../types/curling';
import { api, seg } from './client';

/**
 * Condensed, no-raw-shot-data stats for every team name in one account's own recorded
 * games — what a sponsor sees. Server-computed (see AnalyticsService.accountTeamStats)
 * since a sponsor session never receives full game/shot data to compute this itself.
 */
export const fetchAccountTeamStats = (accountId: string): Promise<TeamStats[]> =>
  api.get<TeamStats[]>(`/analytics/accounts/${seg(accountId)}/team-stats`);
